import { FFInPageEditInput, getInPageEditFullWidth, getInPageEditType } from "components/Freefields/InPageEdit/FFInPageEditInput";
import { FreefieldCategoryWithValuesAndPermissions } from "components/Freefields/models";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { FormSection } from "components/MainSectionTemplate/types";
import { AxiosResponse } from "axios";
import React from "react";

export const freeFieldEditableSections = (
  itemId: number, // The production or show id
  ffCategoriesAndValues: FreefieldCategoryWithValuesAndPermissions[],
  submitFunc: (dto: server.dto.UpdateFreeFieldValueInstruction) => Promise<AxiosResponse<server.dto.ApiResponse, any>>,
): Array<FormSection> => {

  return ffCategoriesAndValues
    .map(category => ({
      key: `${category.freeFieldCategoryId}`,
      type: "collapsable",
      title: category.title,
      fields: category.definitionWithValues
        .map(def => ({
          key: `${def.freeFieldDefinitionId}`,
          label: def.title,
          sublabel: def.description,
          editDisabled: def.permission !== "viewModify",
          hidden: def.permission === "hidden",
          isEmpty: !def.displayValue.value,
          render: () => <ReadonlyFreefieldValue
            type={def.type}
            displayValue={def.displayValue}
          />,
          inPageEdit: {
            type: getInPageEditType(def.type),
            fullWidth: getInPageEditFullWidth(def.type),
            initialValue: def.displayValue.value,
            render: ({ cancel, submit, value, onChange }) => <FFInPageEditInput
              type={def.type}
              value={value}
              onChange={onChange}
              cancel={cancel}
              submit={submit}
              dropdownOptions={def.dropdownOptions}
              reference={def.reference}
            />,
            submitChange: (value: string) => submitFunc({
              definitionId: def.freeFieldDefinitionId,
              value: value,
              itemId,
            })
          },
        })),
    }))
}